/** web-studio-sites D7: what the services piece's current state requires a drawing to show (nothing with no service). */
import type { RequiredParts } from '../../contract/required';
import type { ServicesState } from './contract';

export const requiredParts: RequiredParts<ServicesState> = (state) =>
  state.services.length === 0
    ? []
    : [
        { part: 'list' },
        ...state.services.flatMap((s) => [
          { part: 'item', item: s.id },
          ...['name', 'price'].map((part) => ({ part, item: s.id, in: 'item' })),
          { part: 'book', item: s.id, in: 'item', action: 'open' },
        ]),
      ];
